exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item[data-v-177b7bd1]{margin-bottom:0}[data-v-177b7bd1] .el-form-item--medium .el-form-item__content{line-height:30px}\n", ""]);

// exports
